<div>
    <div class="w-full flex justify-end mb-4">
        <mat-icon  class="cursor-pointer"
            [svgIcon]="'heroicons_solid:x-mark'" 
            (click)="this.dialogRef.close(false)">
        </mat-icon>
    </div>

   <div class="flex flex-col">
        <span class="font-semibold text-2xl py-2">
            Traspaso de Bienes Muebles
        </span>
        <span>
            Por favor, confirme que el nuevo coleccionista está registrado en el sistema antes de realizar el traslado o presione 
            <a (click)="agregarColeccionista()" class="text-blue-600 underline cursor-pointer">aquí</a> 
            para registrar un nuevo coleccionista.
        </span>

   </div>

    <hr class="my-4">

    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="Traslado de coleccionista">
            <ng-template matTabContent>
                <mat-stepper linear #stepper>
                    <mat-step [stepControl]="firstFormGroup">
                        <form (keydown.enter)="$event.preventDefault()">
                            <buscador-coleccionista
                                [ficha]="fichaRegistro"
                                (coleccionistaSeleccionado)="recibirColeccionista($event)"
                                ></buscador-coleccionista>
                            
                            <mat-checkbox 
                                class="mt-4"
                                name="cambioNoRegistro" id="cambioNoRegistro"
                                 [(ngModel)]="cambioNoRegistro">
                                ¿Desea cambiar el número de registro del bien cultural?
                            </mat-checkbox>

                            <div class="w-full flex justify-end mt-4">
                                <button 
                                    mat-raised-button 
                                    class="rounded-sm w-full md:w-4/12" 
                                    matStepperNext
                                    [disabled]="!coleccionistaSeleccionado"
                                    >Siguiente</button>
                            </div>
                        </form>
                    </mat-step>

                    <mat-step [stepControl]="secondFormGroup">
                        <form [formGroup]="secondFormGroup">
                            <buscador-gestiones
                                [tiposGestionesBienesCulturales]="listaGestiones"
                                (gestionesSeleccionadasChange)="gestionesSeleccionadasPadre = $event"
                                ></buscador-gestiones>

                            <div class="flex justify-end gap-4 mt-4">
                                <button mat-raised-button matStepperPrevious
                                class="rounded-sm w-full md:w-4/12">Regresar</button>
                                <button mat-raised-button (click)="guardarTraspasoBienMueble()"
                                    [color]="'primary'"
                                    [disabled]="gestionesSeleccionadasPadre.length < 1"
                                    class="rounded-sm text-white w-full md:w-4/12">
                                    Realizar Traslado
                                </button>
                            </div>
                        </form>
                    </mat-step>
                </mat-stepper>
            </ng-template>
            
        </mat-tab>
        <mat-tab label="Historial de Poseedores">
            <ng-template matTabContent>
                <historial-poseedor [historialPoseedor]="historialPoseedorBienCutural"></historial-poseedor>
            </ng-template>
        </mat-tab>
    </mat-tab-group>   

</div>